module.exports = __webpack_public_path__ + "img/sol_cap4.6d56f2a1.png";